import { SearchQuery } from "@planzone/dto";
import { Selector, State } from "./types";
import { matchQuery } from "./utils";

function createSelector(getState: () => State): Selector {
  const get = (query: SearchQuery) =>
    getState().find((req) => matchQuery(query, req.query));

  return {
    getSearchedResults(query) {
      const req = get(query);

      return req ? req.results : [];
    },
    isSearchRequestFailure(query) {
      const req = get(query);

      return req ? req.request.isFailure : false;
    },
    isSearchRequestPending(query) {
      const req = get(query);

      return req ? req.request.isPending : false;
    },
    isSearchRequestSuccess(query) {
      const req = get(query);

      return req ? req.request.isSuccessful : false;
    },
    canSearch(query) {
      const req = get(query);

      return req ? req.canSearch : false;
    },
    getSearchIndex(query) {
      const req = get(query);

      return req ? req.query.start : 0;
    },
  };
}

export { createSelector };
